import React from 'react';
import { useDispatcher } from '../../data/global/hooks';
import { BlockType } from '@tradingblock/types';
import { BlockActions } from '../../data/global/actions';
import { generateNewBlock } from '../../utilities/block';

export const Column: React.FunctionComponent<{ title?: string; titleClass?: string }> = ({
  title,
  titleClass,
  children,
}) => {
  const isAvailableForTrading = title === 'Available for trading';
  const { dispatcher } = useDispatcher();

  const handleManageFunds = () => {
    const block = generateNewBlock(BlockType.AccountTransfer);
    dispatcher.block.addOrUpdateBlock(block, true, { blockType: BlockType.AccountTransfer });
  };

  const availableForTradingStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };
  return (
    <div className="col" style={isAvailableForTrading ? (availableForTradingStyles as React.CSSProperties) : {}}>
      <div className="prop-stacked">
        <div className={`prop-title ${titleClass}`}>{title}</div>
        {children}
      </div>
      {isAvailableForTrading && (
        <div
          className="available-group"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '12px',
            gap: '8px',
          }}
        >
          <button
            className="btn fund-button"
            title="Manage Funds"
            aria-label="Manage Funds"
            onClick={handleManageFunds}
          >
            <i className="fal fa-money-bill" /> Manage Funds
          </button>
        </div>
      )}
    </div>
  );
};

export interface StackedColumnProps<As extends React.ReactType = 'p' | 'div'> {
  title?: string;
  valueAs?: As;
  className?: string;
}

export const StackedColumn: React.FunctionComponent<StackedColumnProps> = ({ title, valueAs, className, children }) => {
  const ValueElement = valueAs || 'div';
  return (
    <Column title={title}>
      <ValueElement className={className || 'prop-value'}>{children}</ValueElement>
    </Column>
  );
};
